module.exports = __webpack_public_path__ + "static/media/bg-banner-teen-mobile.8aed0e06.jpg";